import { useMutation } from "react-query";
import { EditAutopay } from "../../../../../actions/Utilities/VendorConfiguration";

const useEditAutopay = () => {
  return useMutation(EditAutopay);
};
export default useEditAutopay;
